import React, { useCallback, useState } from "react";
import { Col, Input, Row } from "antd";
import {
   CaretDownOutlined,
   CaretUpOutlined,
   SearchOutlined,
   SlidersOutlined
} from "@ant-design/icons";

import "./SearchFilter.scss";

// TODO: remove handleShowFilters from all components that this component is imported
const SearchFilter = React.memo(
   ({
      handleSearch,
      handleShowFilters,
      handleClearFilters,
      children,
      searchValue: controlledValue
   }) => {
      const [showFilters, setShowFilters] = useState(false);
      const [internalValue, setInternalValue] = useState("");

      const isControlled = controlledValue !== undefined;
      const searchValue = isControlled ? controlledValue : internalValue;

      const toggleFilters = useCallback(() => setShowFilters((prev) => !prev), []);

      const onSearch = useCallback(
         (e) => {
            setInternalValue(e.target.value);
            handleSearch?.(e);
         },
         [handleSearch]
      );

      const onClearFilters = useCallback(() => {
         setInternalValue("");
         handleClearFilters?.();
      }, [handleClearFilters]);

      return (
         <div className="search-filter">
            <Row justify="space-between" gutter={[0, 16]} className="search-filter__toolbar">
               <Col xs={24} sm={24} md={10} lg={10} xl={12}>
                  <Input
                     placeholder="Search..."
                     value={searchValue}
                     onChange={onSearch}
                     suffix={<SearchOutlined />}
                  />
               </Col>
               <Col className="search-filter__actions">
                  {children && (
                     <>
                        {showFilters && (
                           <span className="search-filter__clear" onClick={onClearFilters}>
                              Clear filters
                           </span>
                        )}
                        <button className="search-filter__toggle" onClick={toggleFilters}>
                           <SlidersOutlined />
                           <span>Filters</span>
                           {showFilters ? <CaretUpOutlined /> : <CaretDownOutlined />}
                        </button>
                     </>
                  )}
               </Col>
            </Row>
            {showFilters && children && <div className="search-filter__panel">{children}</div>}
         </div>
      );
   }
);

export default SearchFilter;
